import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Property 1=Lock" }, [
      _createElementVNode("path", {
        id: "Combined Shape",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.2125 10.0702C17.8976 10.227 18.4976 10.6711 18.7923 11.322C18.9258 11.6163 19 11.9431 19 12.2872V18.2984C19 19.5975 17.9466 20.6509 16.6475 20.6509H7.3522C6.05288 20.6509 5 19.5975 5 18.2984V12.2872C5 11.8739 5.10721 11.4857 5.29562 11.1484C5.61093 10.5838 6.16546 10.2074 6.78751 10.0679V8.80679C6.78751 5.86335 9.23885 3.48174 12.2041 3.59546C15.0237 3.70398 17.2125 6.11109 17.2125 8.93274V10.0702ZM15.0006 10.0076V8.89552C15.0006 7.33494 13.8457 5.96796 12.2921 5.82015C10.509 5.65048 9.00204 7.05493 9.00204 8.80679V10.0076H15.0006ZM12.6921 16.2774C12.6921 15.9784 12.8277 15.7026 13.0512 15.5022C13.434 15.1639 13.6526 14.6409 13.569 14.0736C13.465 13.3733 12.8846 12.8193 12.182 12.7412C11.2244 12.6319 10.4125 13.3788 10.4125 14.3156C10.4125 14.797 10.6259 15.2264 10.9668 15.5152C11.1854 15.7078 11.3077 15.9863 11.3077 16.2774V16.5926C11.3077 16.9751 11.6173 17.2848 11.9999 17.2848C12.1896 17.2848 12.3642 17.2067 12.4891 17.0816C12.614 16.9543 12.6921 16.7852 12.6921 16.5926V16.2774Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }